import {Link as RouterLink, useHistory, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {
    GenericFormContainer,
    IAlertData,
    setAlert as SetAlertFunc,
    Spinner,
    apiClient,
    Breadcrumbs,
    Box,
    MuiIcons
} from "@leap4/frontend"
import {RootState} from "../../../../store/store";
import {connect} from "react-redux";
import {DetailsForm} from "../base/DetailsForm";
import {EditTaskStore} from "./EditTaskStore";
import {ITask} from "../../../../interfaces/ITask";
import {initialTaskObj} from "../base/Task";
import {getTaskTypes} from "../base/utils/functions";

const {AddCircle, HomeOutlined, AddTask: AddTaskIcon} = MuiIcons;

// Style objects for breadcrumbs
const linkStyle = { display: "flex", alignItems: "center", color: "inherit", textDecoration: "none" };
const iconStyle = { marginRight: 4, width: 20, height: 20 };

// Mode enum - was previously imported from internal path
enum Mode {
    Create = "create",
    Edit = "edit"
}

export interface IEditTaskProps {
    setAlert: (data: IAlertData) => void
}

let store: EditTaskStore


const _editTask = (props: IEditTaskProps) => {
    const history = useHistory();
    const params = useParams<{ id?: string }>();
    const [task, setTask] = useState<ITask>(initialTaskObj);
    const [isLoading, setIsLoading] = useState(false)
    const [isLoadError, setIsLoadError] = useState(false)

    useEffect(() => {
        if (!params.id) {
            return;
        }
        store = new EditTaskStore({
                setIsLoading,
                setIsLoadError,
                setItem: setTask,
                axiosClient: apiClient,
                alertFunc: props.setAlert,
                baseUrl: process.env.REACT_APP_BACKEND_BASE_URL+'/api/task' || ""
            }
        )
        store.refreshItem(params.id)
    }, [params.id])




    const onSubmit = async () => {
        if (!task._id) {
            return;
        }
        await store.updateById(task._id, task);
        history.goBack();
    };

    const onDelete = async () => {
        if (!task || !task._id) {
            return
        }
        await store.deleteItem(task._id);
        history.goBack();
    };

    if (isLoadError) {
        return (<>Error Loading the page</>)
    }
    if (isLoading) {
        return (<Spinner/>);
    }
    return (
        <>
            <Breadcrumbs>
                <RouterLink to="/" style={linkStyle}>
                    <HomeOutlined style={iconStyle}/>
                    Tasks Dashboard
                </RouterLink>
                <RouterLink to={`/edit/${params.id}`} style={linkStyle}>
                    <AddCircle style={{...iconStyle, marginRight: 10}}/>
                    {"Update"}
                </RouterLink>
                {task.name && (
                    <RouterLink to="/create" style={linkStyle}>
                        <AddTaskIcon style={{...iconStyle, marginRight: 10}}/>
                        {task.name}
                    </RouterLink>
                )}
            </Breadcrumbs>
            <GenericFormContainer mode={Mode.Edit} onCreateOrEditFunc={onSubmit} onDeleteFunction={onDelete} buttonsProps={{goBack:{color:"info"},editCreate:{color:'success'}}}>
                <DetailsForm task={task} updateTask={setTask} mode={"edit"} getTaskTypes={getTaskTypes}/>
            </GenericFormContainer>
        </>
    )
}

const mapStateToProps = (state: RootState) => ({});

export const EditTask = connect(mapStateToProps, {
    setAlert: SetAlertFunc
})(_editTask);